export default {
    set(state, { data }) {
      state.requests = data;
    },
    show(state, { data }) {
      state.request = data;
    }
  }